import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  search: '',
};

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    searched: (state, action) => {
      state.search = action.payload;
    },
  },
});

export const { searched } = tasksSlice.actions;
export default tasksSlice.reducer;
